import { render, staticRenderFns } from "./comprehensiveRank.vue?vue&type=template&id=a10bd918&scoped=true"
import script from "./comprehensiveRank.vue?vue&type=script&lang=js"
export * from "./comprehensiveRank.vue?vue&type=script&lang=js"
import style0 from "./comprehensiveRank.vue?vue&type=style&index=0&id=a10bd918&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a10bd918",
  null
  
)

export default component.exports